import { Grid } from "@mui/material";
import * as React from "react";
import { Create, TextInput, SelectInput, required } from "react-admin";
import { StatusEnum } from "src/common/enum";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { NavigationCreateComponent } from "./NavigationComponent";

export const NavigationCreate = () => {
  return (
    <Create component={NavigationCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} md={6}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput source="status" choices={StatusEnum} validate={required()} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
